export {
  default as garage,
  ReactComponent as Garage,
} from '@assets/icons/features-and-amenities/garage.svg'    
